import { FormControl, MenuItem, Select, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";
import { useState } from "react";

interface NoteFontStyleProps {
    editor: Editor;
    mode: number;
}

const FONT_FAMILIES = [
  'Arial', 'Times New Roman', 'Calibri', 'Georgia', 'Verdana', 'Comic Sans MS', 'Impact'
];

export default function NoteFontStyle({ editor, mode }: NoteFontStyleProps) {
  const [noteFontStyle, setNoteFontStyle] = useState("Arial");

  const handleNoteFontStyleChange = (font: string) => {
    editor.chain().focus().setFontFamily(font).run();
    setNoteFontStyle(font);
  };

 

  return (
    <>
      <Tooltip title="Font">
        <FormControl size="small">
          <Select
            value={noteFontStyle}
            onChange={(e) => handleNoteFontStyleChange(e.target.value)}
            sx={{
                color: mode === 1 ? 'inherit' : 'white',
                fontSize: '12px',
                height: 32,
                flexShrink: 1,
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-icon': {
                  color: mode === 1 ? 'inherit' : 'white',
                },
              }}
            >
            {FONT_FAMILIES.map((font) => (
              <MenuItem key={font} value={font} sx={{ fontFamily: font }}>
                {font}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>
    </>
  );
}
